import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { tap, map } from 'rxjs/operators';
import { XmlparseService } from '../xml/xmlparse.service';
import { DomainService } from 'projects/icemedx-lib/src/services/domain/domain.service';

import { AlertService } from "../../services/alert/alert.service";
import { IceTypes } from "../../models/icetypes";
import { Iceutility } from "../../services/iceutility";
import { LoginService } from 'projects/icemedx-lib/src/login/login.service';
import { vendor } from '../../models/domain/vendor';

declare var require: any;

@Injectable({
  providedIn: 'root'
})
export class VendorService extends DomainService {

  constructor(http: HttpClient,
    alertSvc: AlertService,
    loginSvc: LoginService) {

    super(http, alertSvc, loginSvc);
  }

  insertVendor(ven: vendor, members: string): Observable<any> {
    if (Iceutility.isdefined(ven) == false) throw "Vendor service Insert vendor has invalid parameters.";

    let currentEnv: any = require("../../../../../env.json").currentEnv;
    let envs: any = require("../../../../../env.json").environments;
    if (!envs || !currentEnv) throw "Vendor service is not configured.";

    let url = envs[currentEnv].icemedx_api + "/vendors/default.aspx?domain=&data=addvendor&key=&subkeys=" + "members:" + (members == null ? "" : members);
    let tblname = ven.gettablename().toLowerCase();
    let data = "{" + JSON.stringify(tblname) + ": " + JSON.stringify(ven) + "}";
    return this.getHttp().post(url, data, { responseType: 'text' }).pipe(
      map(
        response => this.geticexdocumentobjects(response, ["VENDOR"])
      ),
      tap(
        data => this.parseLogReport(url, data),
        error => this.parseLogReport(url, error))
    );
  }

  updateVendor(ven: vendor): Observable<any> {
    if (Iceutility.isdefined(ven) == false) throw "Vendor service Insert provider has invalid parameters.";

    let currentEnv: any = require("../../../../../env.json").currentEnv;
    let envs: any = require("../../../../../env.json").environments;
    if (!envs || !currentEnv) throw "Vendor service is not configured.";

    let url = envs[currentEnv].icemedx_api + "/vendors/default.aspx?domain=" + ven.trans_account + "&data=updatevendor&key=&subkeys=domaintype:;lastname:";
    let tblname = ven.gettablename().toLowerCase();
    let data = "{" + JSON.stringify(tblname) + ": " + JSON.stringify(ven) + "}";
    return this.getHttp().post(url, data, { responseType: 'text' }).pipe(
      map(
        response => this.geticexdocumentobjects(response, ["VENDOR"])
      ),
      tap(
        data => this.parseLogReport(url, data),
        error => this.parseLogReport(url, error))
    );
  }

  public getVendors(): Observable<any> {
    let currentEnv: any = require("../../../../../env.json").currentEnv;
    let envs: any = require("../../../../../env.json").environments;
    if (!envs || !currentEnv) throw "Vendor service is not configured.";

    let url = envs[currentEnv].icemedx_api + "/vendors/default.aspx?domain=&data=&key=&subkeys=";
    return this.getHttp().get(url, { responseType: 'text' }).pipe(
      map(
        response => this.geticexdocumentobjects(response, ["VENDOR_INDEX"])
      ),
      tap(
        data => this.parseLogReport(url, data),
        error => this.parseLogReport(url, error))
    );
  }
}
